import config from "../config/configValues";

const Step3 = ({
    className,
    formData,
    handleChange,
    handleLabelChange,
    prevStep,
    handleKeyUp,
    handleSubmit,
    changeDisplayToTrue
}) => {
    return (
        <div className={`card-body ${className}`}>
            {formData.map((object, index) => (
                object.display &&
                <div className="form-row mb-2" key={index}>
                    <div className="form-group">
                        <div className="d-flex align-items-center mr-5">
                            <input
                                type="text"
                                className="form-control"
                                id={`input${object.label}Label`}
                                style={config.labelStyle}
                                value={object.labelTitle}
                                onChange={(e) => handleLabelChange(e, index)}
                                onKeyUp={(e) => handleKeyUp(e, { inputType: "labelTitle", index: index, key: e.key })}
                            />
                             { !object.mandatory && <i className="bi bi-x-lg text-danger" onClick={(e) => changeDisplayToTrue(index)}></i>}
                        </div>
                        {/* <input
                            type={object.dataType}
                            className="form-control"
                            name={object.label}
                            id={`input${object.label}`}
                            placeholder={object.placeholder}
                            value={object.value}
                            onChange={(e) => handleChange(e, index)}
                            onKeyUp={(e) => handleKeyUp(e, { inputType: "value", index: index, key: e.key })}
                        /> */}

{
                                (() => {
                                    switch (object.type) {
                                        case "textarea":
                                            return (
                                                <textarea className="form-control" 
                                                id={`input${object.label}`}
                                                rows="3"
                                                type={object.dataType}
                                                name={object.label}
                                                placeholder={object.placeholder}
                                                value={object.value}
                                                onChange={(e) => handleChange(e, index)}
                                                onKeyUp={(e) => handleKeyUp(e, { inputType: "value", index: index, key: e.key })}></textarea>
                                            );

                                        case "dropdown":
                                            return (<select className="form-control" value={object.value} name={object.label} onChange={(e) => handleChange(e, index)}>
                                                {config.dropdownOptions[object.label].map((option, ind) => (
                                                    <option key={ind} value={option}>
                                                        {option}
                                                    </option>
                                                ))}
                                            </select>)
                                        default:
                                            return (<input
                                                type={object.dataType}
                                                className="form-control"
                                                name={object.label}
                                                id={`input${object.label}`}
                                                placeholder={object.placeholder}
                                                value={object.value}
                                                onChange={(e) => handleChange(e, index)}
                                                onKeyUp={(e) => handleKeyUp(e, { inputType: "value", index: index, key: e.key })}
                                            />) 
                                    }
                                })()}
                    </div>
                </div>
            ))}

            <div className="form-group d-flex justify-content-around my-4">

                <button className="btn btn-primary" type="button" onClick={prevStep}>
                    Previous Page
                </button>
                <div>&nbsp;&nbsp;&nbsp;&nbsp;</div>
                <button className="btn btn-primary" type="button" onClick={handleSubmit}>
                    Submit
                </button>

            </div>
        </div>
    );
}
export default Step3;